import React from 'react';

const Offline = React.memo(() => {
  return <div>네트워크 상태를 확인해주세요</div>;
});

export default Offline;
